export const str = Sk.builtin.str;
export const s_add_event_handler = new str("add_event_handler"), s_add_component = new str("add_component"), s_remove_from_parent = new str("remove_from_parent"), s_raise_event = new str("raise_event"), s_parent = new str("parent"), s_slots = new str("slots"), s_layout = new str("layout"), s_item = new str("item"), s_refresh_data_bindings = new str("refresh_data_bindings"), s_anvil_hooks = new str("_anvil_hooks_"), s_dom_element = new str("dom_element"), s_setup_dom = new str("setup_dom"), s_set_parent = new str("set_parent"), s_page_added = new str("page_added"), s_page_removed = new str("page_removed"), s_page_shown = new str("page_shown"), s_set_data_binding_listener = new str("set_data_binding_listener"), s_get_components = new str("get_components"), s_anvil_events = new str("_anvil_events");
export const getValue = (modName, className) => {
    const pyModule = Sk.sysmodules.quick$lookup(new str(modName));
    if (!pyModule) {
        throw new Sk.builtin.ModuleNotFoundError(`Could not load module ${modName}`);
    }
    return Sk.abstr.gattr(pyModule, new str(className));
};
export const kwToObj = (kws) => {
    const rv = {};
    if (!kws)
        return rv;
    for (let i = 0; i < kws.length; i += 2) {
        rv[kws[i]] = kws[i + 1];
    }
    return rv;
};
export const objToKw = (obj) => {
    const rv = [];
    for (const [argName, pyVal] of Object.entries(obj)) {
        rv.push(argName);
        rv.push(pyVal);
    }
    return rv;
};
